// "Expand all" / "Collapse all" buttons (data-collapse-all="show" or "hide") open or close every Bootstrap
// collapse section inside the surrounding [data-collapse-group]. They click each section's own toggle, so
// rememberCollapse.js saves the new states. Bound once on document so it works across Turbolinks visits.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-collapse-all]');
  if (!button) return;

  const group = button.closest('[data-collapse-group]');
  if (!group) return;

  const open = button.dataset.collapseAll === 'show';
  group.querySelectorAll('.collapse').forEach((section) => {
    if (section.classList.contains('show') === open) return;

    const toggle = group.querySelector(`[data-bs-target="#${section.id}"]`);
    if (toggle) toggle.click();
  });
});
